import React, {useContext, useEffect, useState} from 'react'
import '../styles.css'
import {Grid, useTheme, useMediaQuery} from '@mui/material'
import {GalleryInfoContext} from "../../../components/GalleryInfoContext";

const ImgGallery = () => {
    const theme = useTheme()
    const isLg = useMediaQuery(theme.breakpoints.down('lg'))
    const isMd = useMediaQuery(theme.breakpoints.down('md'))
    const [imageObjects, setImageObjects] = useState([])
    const {galleryInfo} = useContext(GalleryInfoContext);

    // ✅ compute unique URLs directly from contactInfo
    const uniqueImageUrls = React.useMemo(
        () => Array.from(new Set(galleryInfo?.coveringImages || [])),
        [galleryInfo]
    );

    useEffect(() => {
        if (!uniqueImageUrls.length) return;

        // ✅ build objects directly from URLs
        const newImageObjects = uniqueImageUrls.map((url) => ({
            id: url,
            src: url,
        }));

        setImageObjects(newImageObjects);
    }, [uniqueImageUrls]);

    const groupIntoPairs = (array, groupSize) => {
        const pairs = []
        for (let i = 0; i < array.length; i += groupSize) {
            pairs.push(array.slice(i, i + groupSize))
        }
        return pairs
    }

    const pairs = groupIntoPairs(imageObjects, 2)

    // Get actual height values based on breakpoint
    const getHeightValue = (isTall) => {
        if (isMd) {
            return isTall ? 190 : 95;
        } else if (isLg) {
            return isTall ? 380 : 190;
        } else {
            return isTall ? 720 : 370;
        }
    }

    return (
        <Grid container>
            {pairs.map((pair, index) => {
                const height1 = getHeightValue(index % 2 === 0)
                const height2 = getHeightValue(index % 2 !== 0)

                return (
                    <Grid key={index} item sm={6}>
                        <img
                            src={pair[0].src}
                            style={{
                                width: '100%',
                                objectFit: 'cover',
                                height: `${height1}px`,
                                display: 'block' // Add this to prevent inline spacing
                            }}
                            alt={`Gallery image ${index}-1`}
                        />
                        {pair.length > 1 && (
                            <img
                                src={pair[1].src}
                                style={{
                                    width: '100%',
                                    objectFit: 'cover',
                                    height: `${height2}px`,
                                    display: 'block' // Add this to prevent inline spacing
                                }}
                                alt={`Gallery image ${index}-2`}
                            />
                        )}
                    </Grid>
                )
            })}
        </Grid>
    )
}

export default ImgGallery